export class PartitionPlainObject {
    public partitionMethod: string;
    public numberOfPartitions: string;
    public conditions: string[] = [];
}
